module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("ONE")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-p"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("P")]), _vm._v("eter Abrams’s eyesight wasn’t what it used to be. All he could see from here were two figures silhouetted by the morning sun.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The allotment was usually quiet at this time of year, particularly so early in the day. In truth, there wasn’t much to be done. It was far too early to begin any planting, and the ground was still too hard even to prepare the soil for the spring. He focused on clearing the plot of any remaining damaged or rotten winter crops, crouching down to dig them out of the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He came here mainly because he found the place soothing. He was accustomed to being alone – he’d had years of that – but there were still times when he found the silence and emptiness of the house oppressive. The feeling most commonly struck him in the mornings. He always woke earlier than he wanted. That came with age, he supposed.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sometimes, he’d lie there, waiting for sunrise and the start of the day. More often, he’d rise, make himself coffee and breakfast, watch one of the TV news channels. That was fine. He didn’t feel lonely exactly. But sometimes he simply felt as if he needed to leave the house, find some fresh air and sunshine, potter about on the allotment, doing not very much.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He returned his attention to the plot in front of him, digging away at the solid earth with his trowel, pulling out the tired vegetation, oblivious to anything that might be happening around him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Old man.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He looked up again, surprised to find himself being addressed in such a peremptory fashion. He’d assumed initially that the figures were two of his fellow gardeners. Several of them were in a similar position to himself; solitary men who saw this place as a haven from their various troubles. It was unusual for anyone else to be here so early, but not unprecedented. Mostly they kept themselves to themselves, perhaps exchange a greeting, a few sentences about the weather. Then they’d return to their separate plots, busying themselves in their isolated activities. That was how they preferred it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Old man,’ the voice said again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("These days, it took Abrams a minute or two to push himself to his feet. When he was finally upright, he turned to face the men. He saw now that they weren’t anyone he knew. They were young – at least in Abrams’s eyes – and heavily built, with something of a military air. ‘Are you addressing me?’ Abrams said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man who had spoken looked around. ‘I see no one else.’ He spoke perfect English, accentless.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I would prefer not to be addressed in that way. It is discourteous. Disrespectful.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Disrespectful?’ The man repeated the word as if he were weighing it up, considering its meaning or connotations. ‘I simply want to speak with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Speak away. I can’t promise to listen.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man smiled and took a step toward Abrams. Abrams stood his ground, forcing himself not to be intimidated by the man’s manner. ‘The thing is, we know exactly who you are, old man.’ This time, the final phrase sounded as if it were being used more in the English sense, as a term of address. But not exactly, Abrams thought, a term of affection.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What do you mean?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man shrugged. ‘What I say. We know who you are. We know your history. Your past. What you’ve done. Everything you’ve been involved in.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve no idea what you’re talking about. Who "), _c('i', [_vm._v("are")]), _vm._v(" you?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man glanced back at his companion. ‘We’re the clean-up team. We’re here to tidy things. Tie up loose ends.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I don’t understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You don’t need to.’ The man took another step forward.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Now Abrams felt more inclined to retreat, but he knew it was already too late. He was too old. He had done all the running he could many years before, and now there was nowhere left to go. With no other options, he remained motionless, staring defiantly at the two men.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Abrams barely saw the man move. But then he felt the first sharp blow to the side of his head. He fell backwards, collapsing onto the earth he’d been tending only minutes before. He closed his eyes at the second blow, and after that felt nothing more.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-351a762f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 75
// module chunks = 0